import { logger } from "@/lib/logger";

export interface PerformanceMetrics {
  lcp: number | null;
  cls: number | null;
  loadTime: number;
  slug: string;
  lang: string;
  timestamp: string;
  status: 'success' | 'error' | 'timeout' | 'fallback';
  errorReason?: string;
}

export const trackPerformance = (metrics: PerformanceMetrics) => {
  // Use structured logger instead of direct console.log
  logger.debug(`[Performance Telemetry] ${metrics.slug} (${metrics.lang}):`, metrics);
  
  if (typeof window !== 'undefined') {
    const eventName = `perf_${metrics.status}`;
    try {
      // trackEvent is available in lib/analytics
      import('@/lib/analytics').then(({ trackEvent }) => {
        trackEvent({
          action: eventName,
          category: 'performance',
          label: `${metrics.slug}_${metrics.lang}`,
          value: metrics.loadTime
        });
      });
    } catch (e) {
      logger.error("Telemetry failed:", e);
    }
  }
};

export const getVitals = () => {
  let lcp: number | null = null;
  let cls: number | null = 0;

  if (typeof window !== 'undefined' && 'PerformanceObserver' in window) {
    // Simplified vitals gathering
    try {
      new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        const lastEntry = entries[entries.length - 1];
        lcp = lastEntry.startTime;
      }).observe({ type: 'largest-contentful-paint', buffered: true });

      new PerformanceObserver((entryList) => {
        for (const entry of entryList.getEntries()) {
          if (!(entry as any).hadRecentInput) {
            cls = (cls || 0) + (entry as any).value;
          }
        }
      }).observe({ type: 'layout-shift', buffered: true });
    } catch (e) {
      console.warn("Vitals observation failed:", e);
    }
  }
  return { getLCP: () => lcp, getCLS: () => cls };
};
